module.exports = __webpack_public_path__ + "static/media/star_gray.1c218c68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stars/star_gray.svg
// module id = 331
// module chunks = 0